import { RemoteGetSummaryProfile } from 'data/usecases';
import { GetSummaryProfile } from 'domain/usecases';
import { makeApiUrlSummaryProfile } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetSummaryProfile = (): GetSummaryProfile =>
  new RemoteGetSummaryProfile(
    makeApiUrlSummaryProfile(),
    makeAxiosHttpClient(),
  );
